import React from 'react';
import ColorfulIcon from './ColorfulIcon';
import { solutions } from '../mockData';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const iconGradients = ['blue', 'purple', 'green', 'orange', 'teal', 'indigo', 'rose', 'amber'];

const Solutions = () => {
  return (
    <section id="solutions" className="py-6 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-6">
          <p className="text-blue-600 text-sm font-semibold tracking-wider uppercase mb-2" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Business Solutions
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif', letterSpacing: '-0.02em' }}>
            IT Solutions
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Cutting-edge technology solutions to secure, scale, and streamline your business
            operations from endpoint to cloud.
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {solutions.map((solution, index) => {
            return (
              <div
                key={solution.id}
                className="group bg-gray-50 hover:bg-white border border-gray-200 rounded-3xl p-6 hover:shadow-lg transition-all duration-300"
              >
                <div className="mb-4">
                  <ColorfulIcon 
                    icon={solution.icon} 
                    size={24} 
                    gradient={iconGradients[index % iconGradients.length]} 
                    className="mb-3"
                  />
                  <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif' }}>{solution.title}</h3>
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
                    {solution.description}
                  </p>
                </div>
                <Button
                  variant="ghost"
                  className="text-blue-600 hover:text-blue-700 p-0 h-auto group-hover:gap-2 transition-all"
                >
                  Learn More
                  <ArrowRight size={16} className="ml-1" />
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Solutions;